module.exports = __webpack_public_path__ + "img/home.12561096.svg";